import { countriesWithCode } from 'assets/files/countriesWithCode';

export const getCountryCode = (code: string) => {
  const country = countriesWithCode.find((item: any) => item.countryCode === code);
  return country ? country.isoCode : '';
};
